import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

import { RootContainers } from '@/modules/common/helpers';

export default function MUIModal(theme: Theme): Components['MuiModal'] {
  return {
    defaultProps: {
      container: RootContainers.getMUIPortalContainer(),
      disableScrollLock: true,
    },
    styleOverrides: {
      root: {
        zIndex: theme.zIndex.modal,
      },
    },
  };
}
